// Data imported from siddhijambuparivar.com
// This file contains content from the official Siddhi Jambu Parivar website

export const gurudevBio = {
  name: "Gurudev Muni Jambuvijayaji Maharaj Saheb",
  hindiName: "आगमप्रज्ञ पू. मुनिराज श्री जम्बू विजयजी महाराज साहेब",
  birthName: "Chunilal Bhogilal Joitram",
  birthYear: 1923,
  deathYear: 2009,
  birthPlace: "Mandal, Gujarat",
  fatherName: "Mohanlal Bhogial Joitram (Bhuvanvijayaji Maharaj)",
  fatherYears: "1895–1959",
  motherName: "Maniben Popatlal (Sadhvi Sri Manoharshriji Maharaj)",
  motherYears: "1894–1995",
  order: "Tapa Gaccha order of Shwetambar sect of Jainism",
  mainImage:
    "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-29-778x1024.png",
  centenaryLogo:
    "https://siddhijambuparivar.com/wp-content/uploads/2019/07/MicrosoftTeams-image-26-370x400.png",
  shortBio:
    "Muni Jambuvijayaji Maharaj Saheb (1923–2009), also known as Gurudev Muni Jambuvijayaji Maharajsaheb, was a monk belonging to the Tapa Gaccha order of Shwetambar sect of Jainism. Muni Jambuvijayaji was born as Chunilal Bhogilal Joitram in 1923 in town of Mandal, Gujarat. His father's name was Bhogilal Mohanlal Joitram (1895–1959) and his mother's name was Aniben Popatlal (1894–1995). He was born into a deeply religious family.",
};

// Complete gallery images from siddhijambuparivar.com/photo-gallery/
export const galleryImages = [
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/43-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/43-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/96-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/96-min-370x400.jpg",
    alt: "Gurudev in meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/29-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/29-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/76-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/76-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/48-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/48-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/36-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/36-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/75-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/75-min-370x400.jpg",
    alt: "Gurudev in white robes",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/77-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/77-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/83-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/83-min-370x400.jpg",
    alt: "Gurudev portrait photo",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/93-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/93-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj Saheb",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/101-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/101-min-370x400.jpg",
    alt: "Several men dressed in white robes are gathered around Pujya Bapu",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/69-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/69-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/97-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/97-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/37-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/37-min-370x400.jpg",
    alt: "Gurudev teaching disciples",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/100-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/100-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/78-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/78-min-370x400.jpg",
    alt: "Gurudev in contemplation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/6.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/6-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/102-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/102-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/5-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/5-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/34-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/34-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/116-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/116-min-370x400.jpg",
    alt: "Gurudev in Jain attire",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/5.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/5-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/90-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/90-min-370x400.jpg",
    alt: "Gurudev with manuscripts",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/59-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/59-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/19-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/19-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/86-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/86-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/1-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/1-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/WhatsApp-Image-2020-10-21-at-11.31.36-PM-1.jpeg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/WhatsApp-Image-2020-10-21-at-11.31.36-PM-1-370x400.jpeg",
    alt: "Gurudev event",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/22-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/22-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/11-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/11-min-370x400.jpg",
    alt: "Gurudev blessing devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/68-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/68-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-18.png",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-18-370x400.png",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/41-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/41-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/72-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/72-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/18-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/18-min-370x400.jpg",
    alt: "Gurudev in meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/3-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/3-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/64-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/64-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/42-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/42-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/26-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/26-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/104-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/104-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/53-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/53-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/74-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/74-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/107-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/107-min-370x400.jpg",
    alt: "A collective of individuals in white robes",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/2-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/2-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/39-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/39-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/10-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/10-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/15-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/15-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/79-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/79-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/45-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/45-min-370x400.jpg",
    alt: "Gurudev blessing devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/66-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/66-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/63-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/63-min-370x400.jpg",
    alt: "Gurudev with manuscripts",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/7-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/7-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/4.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/4-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/50-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/50-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/99-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/99-min-370x400.jpg",
    alt: "Jambuvijayji Maharaj Saheb analyzing papers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/56-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/56-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-20.png",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-20-370x400.png",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/9.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/9-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/24-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/24-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/65-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/65-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/49-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/49-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/47-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/47-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/105-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/105-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/46-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/46-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/120-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/120-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/54-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/54-min-370x400.jpg",
    alt: "Gurudev blessing devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/106-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/106-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/16-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/16-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/94-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/94-min-370x400.jpg",
    alt: "Gurudev with manuscripts",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/4-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/4-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/8.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/8-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/60-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/60-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/1.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/1-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/84-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/84-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/32-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/32-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/35-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/35-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/40-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/40-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/71-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/71-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/67-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/67-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/58-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/58-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-19.png",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-19-370x400.png",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/30-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/30-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/21-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/21-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/6-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/6-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/52-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/52-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/61-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/61-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/28-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/28-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/3.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/3-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/7.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/7-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/23-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/23-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/57-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/57-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/14-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/14-min-370x400.jpg",
    alt: "Gurudev blessing devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/17-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/17-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/51-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/51-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/20-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/20-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/55-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/55-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/80-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/80-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/44-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/44-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/88-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/88-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/92-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/92-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/13-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/13-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/12-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/12-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/9-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/9-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/62-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/62-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/25-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/25-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/89-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/89-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/27-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/27-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/111-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/111-min-370x230.jpg",
    alt: "Jambuvijayji Maharaj Saheb sits contemplatively",
  },
];

// Complete books collection from siddhijambuparivar.com/shop/
export const books: {
  id: number;
  title: string;
  image: string;
  link: string;
  category: string;
  language: string;
}[] = [];

// Videos from siddhijambuparivar.com
export const videos: {
  id: number;
  title: string;
  channel: string;
  url: string;
  description: string;
}[] = [];

// Events from siddhijambuparivar.com
export const events: {
  id: number;
  title: string;
  titleEn: string;
  date: string;
  type: string;
  image: string;
  link: string;
}[] = [];

// Blog posts (sample content based on site themes)
export const blogPosts: {
  id: number;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  readTime: string;
  category: string;
  image: string;
}[] = [];

// Articles & Tributes
export const articles: {
  id: number;
  title: string;
  titleEn: string;
  author: string;
  category: string;
  language: string;
  excerpt: string;
  image: string;
}[] = [];

// Documents collection
export const documents: {
  id: number;
  title: string;
  titleHindi: string;
  type: string;
  description: string;
  language: string;
}[] = [];

// Categories for filtering
export const bookCategories = [
  "All",
  "Agam",
  "Guruvani",
  "Sutra",
  "Granthsuchi",
  "Tika",
  "Grammar",
  "Philosophy",
  "Research",
];

export const articleCategories = ["All", "Article", "Tribute", "Document"];

export const blogCategories = [
  "All",
  "Philosophy",
  "History",
  "Education",
  "Art & Culture",
  "Events",
  "Technology",
];
